export const PATHS = {
  home: '/',
  login: '/login',
  setPassword: '/set-password',
  resetPassword: '/reset-password',
  products: '/products',
  assets: '/assets-list',
  assetsAdd: '/assets-add',
  assetsEdit: '/assets-edit',
  assetsSearch: '/assets-search',
  packages: '/packages',
  notFoundPage: '/not-found-page',
  productAdd: '/product-add',
  productEdit: '/product-edit',
  cardPreview: '/card-preview',
  privacyPolicy: '/privacy-policy',
  policyAcceptance: '/policy-acceptance',
  packageDetails: '/packages/:token',
  iframePreview: '/iframe/:token',
  NotPermittedPage: '/not-permitted-page',
  admin: '/admin',
  userManagement: '/admin/users',
  userCreate: '/admin/users/create',
  userEdit: '/admin/users/edit/:id',
  userView: '/admin/users/view/:id',
  aiLimitsManagement: '/admin/ai-limits',
  imageEditor: '/image-editor',
  aiContext: '/admin/ai-context',
  brandContextAdd: '/admin/brand-context/add',
  brandContextEdit: '/admin/brand-context/edit/:brandId/:country',
  extendedContextAdd: '/admin/extended-context/add',
  extendedContextEdit: '/admin/extended-context/edit/:id',
  analytics: '/admin/analytics',
  iframes: '/iframes',
  christmasCards: ['/magda', '/andrzej', '/michal', '/roksolana', '/patryk', '/klaudia', '/piotr', '/marcin', '/szymon', '/alicja'],
  landingPages: '/landing-pages',
  landingPagesAdmin: '/admin/landing-pages',
  /** Dev tools — LP font catalog CRUD */
  landingPageFonts: '/admin/landing-page-fonts',
  landingPagesAdd: '/landing-page/add',
  landingPagesEdit: '/landing-page/edit',
  landingPagePreview: '/landing-page-preview',
  /** @deprecated Legacy entry; new links use reviewSessionAccess */
  reviewAccess: '/review/access',
  /** Public reviewer entry — one URL per review session (bookmark after first open). */
  reviewSessionAccess: '/review/sessions/:sessionId',
  reviews: '/reviews',
  reviewsLandingPages: '/reviews/landing-pages',
  reviewsProducts: '/reviews/products',
  reviewSessionDetail: '/reviews/:sessionId',
  reviewSessionRoom: '/reviews/:sessionId/room',
  landingPagesAssets: '/landing-pages/assets',
  landingPagesAssetsAdd: '/landing-page/asset/add',
  landingPagesAssetsEdit: '/landing-page/asset/edit',
  landingPagesPackages: '/landing-page/packages',
  landingPagesIframes: '/landing-page/iframes',

  /** Admin – Brands Management (subcards: assets form settings, static translation, …) */
  brandsManagement: '/admin/brands'
}
